import { render, staticRenderFns } from "./DogIosGoods.vue?vue&type=template&id=6687bbb2&scoped=true"
import script from "./DogIosGoods.vue?vue&type=script&lang=js"
export * from "./DogIosGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687bbb2",
  null
  
)

export default component.exports